// Shared attendance display helpers (status/result meta + MYT time formatting).
const MYT = "Asia/Kuala_Lumpur";

export const STATUS_META = {
  clocked_in: { label: "Clocked In", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  completed: { label: "Completed", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  unscheduled: { label: "Unscheduled", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  exception_pending: { label: "Exception Pending", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  exception_approved: { label: "Exception Approved", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  exception_rejected: { label: "Exception Rejected", cls: "bg-rose-100 text-rose-700 border-rose-300" },
  none: { label: "—", cls: "bg-slate-50 text-slate-400 border-slate-200" },
};

export const RESULT_META = {
  pass: { label: "Pass", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  fail: { label: "Fail", cls: "bg-rose-100 text-rose-700 border-rose-300" },
  fail_out_of_range: { label: "Out of range", cls: "bg-rose-100 text-rose-700 border-rose-300" },
  poor_accuracy: { label: "Poor GPS", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  no_gps: { label: "No GPS", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  no_ip: { label: "No IP", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  no_location_configured: { label: "No location set", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  no_qr: { label: "No QR", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  no_qr_configured: { label: "No QR set", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  not_required: { label: "—", cls: "bg-slate-50 text-slate-400 border-slate-200" },
};

export const OVERALL_META = {
  passed: { label: "Verified", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  exception_required: { label: "Needs Exception", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  failed: { label: "Failed", cls: "bg-rose-100 text-rose-700 border-rose-300" },
};

export const statusMeta = (s) => STATUS_META[s] || STATUS_META.none;
export const resultMeta = (r) => RESULT_META[r] || RESULT_META.not_required;
export const overallMeta = (o) => OVERALL_META[o] || { label: o || "—", cls: "bg-slate-50 text-slate-400 border-slate-200" };

export const fmtTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleTimeString("en-GB", { timeZone: MYT, hour: "2-digit", minute: "2-digit" });
  } catch { return "—"; }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-GB", { timeZone: MYT, day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch { return "—"; }
};

// Read the browser geolocation. Resolves with {latitude, longitude, accuracy} or {location_denied:true}.
export const getPosition = () => new Promise((resolve) => {
  if (!("geolocation" in navigator)) return resolve({ location_denied: true });
  navigator.geolocation.getCurrentPosition(
    (pos) => resolve({ latitude: pos.coords.latitude, longitude: pos.coords.longitude, accuracy: pos.coords.accuracy }),
    () => resolve({ location_denied: true }),
    { enableHighAccuracy: true, timeout: 12000, maximumAge: 0 }
  );
});
